import { createTestIds } from '@pega/cosmos-react-core';

export const getRichTextViewerTestIds = createTestIds('rich-text-viewer', [] as const);
